import { Actions } from './actions';
import { message } from 'antd';

const Reducer = (state, action) => {
	switch (action.type) {
		case Actions.GET_PROJECT_RELATED_DATA_SUCCESS:
			return {
				...state,
				projectVendorDetails: action.payload.project,
			};
		case Actions.GET_PROJECT_RELATED_DATA_FAILED:
			message.error(action.payload);
			return state;
		case Actions.GET_ALL_VENDER_LIST_DATA_SUCCESS:
			return {
				...state,
				projectEventDetails: action.payload.vendorEventsList,
			};
		case Actions.GET_ALL_VENDER_LIST_DATA_FAILED:
			message.error(action.payload);
			return state;
		default:
			return state;
	}
};

export default Reducer;
